import { CompositeScreenProps } from '@react-navigation/native'
import React, { useMemo, useState } from 'react'

import { NavMenuButton } from 'partials/MobileNav/types'
import { Page } from 'partials/Page'
import { UserProfilePreview } from 'partials/UserProfilePreview'

import { Modal } from 'widgets/Modal'
import { OptionItem } from 'widgets/OptionsDropdown/subcomponents/OptionItem'

import { useCurrentUser } from 'hooks/useCurrentUser'

import { links } from 'utils/constants'
import { copyProfileUrl, getProfileLink } from 'utils/links/links'
import { handleShareAction } from 'utils/sharing'

export const ProfilePage = ({ navigation }: CompositeScreenProps<any, any>) => {
  const { data: user, isLoading: isUserLoading } = useCurrentUser()
  const [isOptionsModalVisible, setIsOptionsModalVisible] = useState(false)
  const [isCommentLoading, setIsCommentLoading] = useState(false)
  const isLoading = useMemo(
    () => isUserLoading || isCommentLoading,
    [isCommentLoading, isUserLoading],
  )

  if (!user) return null

  const menuOptions = ['Copy Profile Link', 'Share Profile', 'Groups', 'Account']

  const handleShowOptionsMenuPress = () => {
    setIsOptionsModalVisible(true)
  }

  const handleCloseOptionsMenuPress = () => {
    setIsOptionsModalVisible(false)
  }

  const optionsMenuButton: NavMenuButton = {
    iconName: 'options-menu',
    onPress: handleShowOptionsMenuPress,
  }

  const handleShareProfileOption = async (): Promise<void> => {
    const url = getProfileLink(user?.username as string)
    const message = `Check out ${user?.firstName} ${user?.lastName}'s Group!`
    await handleShareAction(url, message, navigation, links.SHARE_PROFILE_PAGE)
  }

  const handleMembershipsOption = () => {
    navigation.navigate(links.PROFILE_STACK, {
      screen: links.MEMBERSHIPS_PAGE,
    })
  }

  const handleAccountOption = (): void => {
    navigation.navigate(links.ACCOUNT_PAGE)
  }

  const handleOnSelect = async (index: number) => {
    if (index === 0) {
      await copyProfileUrl(user?.username as string)
    } else if (index === 1) {
      await handleShareProfileOption()
    } else if (index === 2) {
      handleMembershipsOption()
    } else if (index === 3) {
      handleAccountOption()
    }
  }

  return (
    <Page
      withNav
      navigation={navigation}
      backgroundColor='white'
      title={`${user?.firstName} ${user?.lastName}`}
      withLogoButton
      navbarRightButtons={[optionsMenuButton]}
      isLoading={isLoading}
    >
      <UserProfilePreview user={user || {}} setIsCommentLoading={setIsCommentLoading} />

      <Modal
        isVisible={isOptionsModalVisible}
        onClose={handleCloseOptionsMenuPress}
        variant='fullscreenModal'
      >
        {menuOptions.map((option, index) => {
          return (
            <OptionItem
              key={option}
              option={option}
              isCancelItem={false}
              onSelect={async () => {
                await handleOnSelect(index)
                setIsOptionsModalVisible(false)
              }}
            />
          )
        })}
        <OptionItem isCancelItem onSelect={handleCloseOptionsMenuPress} />
      </Modal>
    </Page>
  )
}
